import { render, staticRenderFns } from "./ServerList.vue?vue&type=template&id=419e5b9a&"
import script from "./ServerList.vue?vue&type=script&lang=js&"
export * from "./ServerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ServerList.vue"
export default component.exports